import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
main: {
    display:"flex",
    flexDirection:"column",
    alignItems:"center",
    paddingRight:"40px",
    paddingLeft:"40px",
    paddingTop:"48px",
    marginBottom:"150px",
},
discribeSection: {
    display:"flex",
    flexDirection:"column",
    alignItems:"start",
    marginTop:"40px",
    width:"100%",
    gap:"10px",
},
winnerTitleSection: {
    display:"flex",
    justifyContent:"space-between",
    width:"100%",
    marginTop:"40px",
    marginBottom:"26px",
},
winnerSection: {
    display:"flex",
    flexDirection:"column",
    gap:"18px",
    width:"100%",
},
titleText: {
    fontSize:"20px !important",
    fontStyle:"bold",
    color:"#ffffff",
},
detailText: {
    fontSize:"14px !important",
    color:"#c1c1c1",
},
viewMoreText: {
    fontSize:"14px !important",
    color:"#ddb930",
},
}));

export default useStyles;
